import {
  Event,
  EventBuilder as EventBuilderInterface,
  EventType,
} from "@jupiter/types";
import get from "lodash-es/get";
import isEmpty from "lodash-es/isEmpty";
import isNil from "lodash-es/isNil";
import isObject from "lodash-es/isObject";
import isString from "lodash-es/isString";
import set from "lodash-es/set";
import { Md5 as md5 } from "md5-typescript";
import { parseUrl } from "query-string";

export const EventBuilder: EventBuilderInterface = {
  createExceptionEvent(
    exception: any,
    otherProperties?: Record<string, any>
  ): Event {
    return {
      event: {
        name: "error",
        type: EventType.ERROR,
        data: {
          brief: isNil(exception)
            ? md5.init("Unknown Error")
            : md5.init(exception),
          stack: isNil(exception) ? "Unknown Error" : exception,
          ...otherProperties,
        },
      },
    };
  },
  createCustomEvent(
    eventName: string,
    otherProperties?: Record<string, any>
  ): Event {
    return {
      event: {
        name: eventName,
        type: EventType.CUSTOM_EVENT,
        data: {
          ...otherProperties,
        },
      },
    };
  },
  createPageViewEvent(
    from: string | null | undefined,
    to: string | null | undefined,
    otherProperties?: Record<string, any>
  ): Event {
    if (isString(from)) {
      if (from[from.length - 1] == "?") {
        from = from.substring(0, from.length - 1);
      }
    }

    if (isString(to)) {
      const hasHashRegex = /^(.*)\/?#\//;
      const hashMatchResult = to.match(hasHashRegex);

      hashMatchResult && (to = to.replace(hasHashRegex, ""));
      const parsedUrl = parseUrl(to);

      if (!isEmpty(parsedUrl.query)) {
        if (isObject(otherProperties)) {
          set(otherProperties, "query", {
            ...get(otherProperties, "query"),
            ...parsedUrl.query,
          });
        } else if (isNil(otherProperties)) {
          otherProperties = { query: parsedUrl.query };
        }
      }

      if (hashMatchResult) {
        !isEmpty(parsedUrl.url) &&
          (to = `${hashMatchResult[0]}${parsedUrl.url}`);
      } else {
        parsedUrl.url && (to = parsedUrl.url);
      }
      if (/^#?\//.test(to)) {
        to = to.replace(/^#?\//, "");
      }
    }

    return {
      event: {
        name: "pv",
        type: EventType.PV,
        data: {
          ...otherProperties,
          from,
          to,
        },
      },
    };
  },
};
